import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  advWorkflow as advWorkflowSelector,
  currentClientId as currentClientIdSelector,
} from '../AdvWorkflow/AdvWorkflowSelector';

export const hasLargePurchaseWorkflowData = state => !!state.AdvWorkflow.LargePurchaseWorkflow;

export const clientId = currentClientIdSelector;

const largePurchaseWorkflow = createSelector(
  advWorkflowSelector,
  currentClientIdSelector,
  (advWorkflow, currentClientId) => get(advWorkflow, currentClientId, {}),
);

export const largePurchaseWorkflowData = createSelector(largePurchaseWorkflow, ({ data }) => data);

export const largePurchaseWorkflowData2 = createSelector(
  largePurchaseWorkflow,
  ({ data2 }) => data2,
);

export const largePurchaseWorkflowCombinedData = createSelector(
  largePurchaseWorkflowData,
  largePurchaseWorkflowData2,
  (data, data2) => ({ ...data, ...data2 }),
);
